import { useClaims } from "@/hooks/useClaims";
import { ClaimCard } from "./ClaimCard";

interface UserClaimsListProps {
  userId: string;
}

export const UserClaimsList = ({ userId }: UserClaimsListProps) => {
  const { claims, loading } = useClaims(userId);

  if (loading) {
    return <div className="animate-pulse bg-gray-100 h-32 rounded-lg" />;
  }

  if (claims.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        You have no claims at this time.
      </div>
    );
  }

  return (
    <div>
      <div className="space-y-4">
        {claims.map((claim) => (
          <ClaimCard key={claim.id} claim={claim} />
        ))}
      </div>
    </div>
  );
};